import { MapPin } from "lucide-react";

type Props = {
  addressLines: string[];
  apiKey?: string | null;
};

const mapDimensions = { aspectRatio: "1/1", minHeight: 220, maxHeight: 380, maxWidth: 380 };

export const AddressMap = ({ addressLines, apiKey }: Props) => {
  if (!apiKey) return null;

  if (addressLines.length === 0) {
    return (
      <div
        className="mt-2 w-full rounded flex flex-col items-center justify-center gap-2.5 border border-dashed border-gray-200 bg-gray-50 text-gray-400"
        style={mapDimensions}
      >
        <MapPin size={32} strokeWidth={1.5} />
        <span className="text-[13px]">No address on record</span>
      </div>
    );
  }

  const src = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${encodeURIComponent(addressLines.join(", "))}`;

  return (
    <iframe
      title="Location map"
      src={src}
      className="mt-2 w-full rounded border-0"
      style={mapDimensions}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      allowFullScreen
    />
  );
};
